import { render, staticRenderFns } from "./ReservaConfirmation.vue?vue&type=template&id=7c6351d8&"
import script from "./ReservaConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReservaConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports